import { Component, OnInit } from '@angular/core';
import { CatalogueService } from 'app/components/catalogue/catalogue.service';
import { DomService } from 'app/components/dom/dom.service';
import { ActivatedRoute, Router } from '@angular/router';
import {ModalYesNoComponent} from "../../components/modal-yes-no/modal-yes-no.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-exhibitor-backoffice-exhibitor-create',
  templateUrl: './exhibitor-backoffice-exhibitor-create.component.html',
  styleUrls: ['./exhibitor-backoffice-exhibitor-create.component.css']
})
export class ExhibitorBackofficeExhibitorCreateComponent implements OnInit {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';

  exhibitorData: object = {};

  eventName: string|null = '';
  buttonLink: string = '';
  
  private readonly destroy$ = new Subject();

  activeMultiEvents: boolean = false;
  multiEvent: any = [];
  catalogueId: number;
  catalogueLabel: string = '';
  selectedMultiEvent: object = {};

  constructor(public catalogueService: CatalogueService, private domService: DomService,
              private activatedRoute: ActivatedRoute, private router: Router, private modalService: NgbModal) {
    this.eventName = this.activatedRoute.snapshot.paramMap.get('event') || null;
    this.buttonLink = this.eventName + '/exhibitor-backoffice/exhibitors';
  }


  cancel() {
    this.router.navigate([this.buttonLink]);
  }

  saveBtn() {

    this.exhibitorData['multiEventId'] = this.selectedMultiEvent['multiEventId'];

    let createExhibitorIn = {
      catalogueId: this.catalogueService.getProperty('id'),
      accountId: this.catalogueService.getProperty('accountId'),
      id: -1,
      name: this.exhibitorData['name'],
      published: this.exhibitorData['published'],
      sapEmail: this.exhibitorData['email'],
      sapId: this.exhibitorData['sapId'] || '',
      sapOrderId: this.exhibitorData['orderSapId'] || '',
      sapOrderParentId: this.exhibitorData['fatherOrderSapId'],
      username: this.exhibitorData['user']
    }

    if(this.exhibitorData['multiEventId']){
      createExhibitorIn['multiEventId'] = this.exhibitorData['multiEventId'];
    }

    this.createExhibitor(createExhibitorIn);

  }

  createExhibitor(createExhibitorIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.catalogueService.createExhibitor(createExhibitorIn)
      .subscribe((data: object) => {
        this.createExhibitorOk(data);
      },
        error => {
          this.createExhibitorError(error);
        });

  }

  createExhibitorOk(data) {
    this.loader.count--;
    this.isRedirectToEditExhibitor(data);
  }

  createExhibitorError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }
  
  getCatalogueMultiEvents(getCatalogueMultiEventsIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.catalogueService.getCatalogueMultiEvents(getCatalogueMultiEventsIn)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: data => this.getCatalogueMultiEventsOk(data),
        error: error => this.getCatalogueMultiEventsError(error)
      });

  }

  getCatalogueMultiEventsOk(data) {

    this.loader.count--;
    this.activeMultiEvents = true;

    this.selectedMultiEvent = {label:this.catalogueLabel, sapCode:this.catalogueService.getProperty('sapCode'), multiEventId:null};

    this.multiEvent.push(this.selectedMultiEvent);

    for (let index = 0; index < data.length; index++) {

      const element = data[index];

      this.multiEvent.push({label:element.label, sapCode:element.salon, multiEventId:''+element.id});
      
    }

  }

  getCatalogueMultiEventsError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }


  isRedirectToEditExhibitor(data) {
    
    const modalRef = this.modalService.open(ModalYesNoComponent);
    modalRef.componentInstance.question = 'MODAL_YES_NO.REDIRECT_TO_EDIT_EXHIBITOR';

    modalRef.result.then( (option) => {

      if (option === 'yes') {

        this.router.navigate([this.buttonLink + '/' + data['id'] + '/edit']);

      } else {

        this.exhibitorData['name'] = null;
        this.exhibitorData['published'] = null;
        this.exhibitorData['email'] = null;
        this.exhibitorData['sapId'] = null;
        this.exhibitorData['orderSapId'] = null;
        this.exhibitorData['fatherOrderSapId'] = null;
        this.exhibitorData['user'] = null;
        this.router.navigate([this.buttonLink + '/exhibitor-create']);

      }

    });

  }

  ngOnInit() {

    let catalogueId = this.catalogueService.getProperty('id');
    this.catalogueLabel = this.catalogueService.getProperty('eventName');
    this.domService.addClassToBody('bg-gray');
    
    let getCatalogueIn = {
      catalogueId: catalogueId
    }

    this.getCatalogueMultiEvents(getCatalogueIn);
  }

  ngOnDestroy() {
    this.domService.removeClassFromBody('bg-gray');
  }

}

